module.exports = __webpack_public_path__ + "static/img/close.27898263.png";